import React, { Fragment, useContext, useState } from "react";
import DataTable from "react-data-table-component";
import { DropdownItem } from "reactstrap";
import ActionOptions from "../../Common/Component/ActionOptions";
import moment from "moment";
import { Spinner } from "../../../AbstractElements";
import CommonToolTip from "../../Common/Component/CommonToolTip";
import { unavailableCarColumns } from "../../../Data/Driver/CarListing";
import CustomizerContext from "../../../_helper/Customizer";

const UnavailableCarTable = ({
    tableData,
    setShowApiLoader,
    fetchTableData,
    paginationPerPage,
    paginationTotalRows,
    onChangePage,
    onChangeRowsPerPage,
    loader,
}) => {
    const {mix_background_layout} = useContext(CustomizerContext)


    const processData = tableData.map((element, index) => {
        return {
            carNo: element.carNo ? element.carNo : "-",
            unavailableDate: element.unavailableDate ? moment(new Date(element.unavailableDate)).format("MMM DD HH:mm") : "-",
            createdOn: element.createdOn ? moment(new Date(element.createdOn)).format("MMM DD HH:mm") : "-",
            createdByName: element.createdByName ? element.createdByName : "-",
            availableByName: element.availableByName ? element.availableByName : "-",
            blockedReason: element.blockedReason
                ?
                <>
                    <span
                        id={"blockedReason" + index}
                        style={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {element.blockedReason}
                    </span>
                    <CommonToolTip
                        options={{
                            placement: "left",
                            target: "blockedReason" + index,
                        }}
                    >
                        {element.blockedReason}
                    </CommonToolTip>
                </>
                : "-",
            unblockedReason: element.unblockedReason
                ?
                <>
                    <span
                        id={"unblockedReason" + index}
                        style={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {element.unblockedReason}
                    </span>
                    <CommonToolTip
                        options={{
                            placement: "left",
                            target: "unblockedReason" + index,
                        }}
                    >
                        {element.unblockedReason}
                    </CommonToolTip>
                </>
                : "-",
            isResolved: element.isResolved ? "True" : "False",
        };
    });
    return (
        <Fragment>
            <div className="table-responsive">
                <DataTable
                    columns={unavailableCarColumns}
                    data={processData}
                    center={true}
                    fixedHeader
                    fixedHeaderScrollHeight={"57vh"}
                    pagination
                    paginationPerPage={paginationPerPage}
                    paginationTotalRows={paginationTotalRows}
                    onChangePage={onChangePage}
                    onChangeRowsPerPage={onChangeRowsPerPage}
                    // customStyles={customStyles}
                    paginationServer
                    progressPending={loader}
                    progressComponent={<div className="loader-box" style={{ height: "57vh" }}>
                        <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
                    </div>}
                    theme={mix_background_layout == "dark-only" ? "dark" : "default"}
                />
            </div>

        </Fragment>
    );
};

export default UnavailableCarTable;
